module.exports = __webpack_public_path__ + "static/media/warning.d4ac66ca.svg";